import * as React from 'react'
import { CheckoutErrorDialog } from '@/scopes/checkout/components/CheckoutError/CheckoutErrorDialog'
import { useCheckoutSid, useRouterIsReady } from '@/scopes/checkout/domain/hooks'
import styles from './styles.module.css'

export function PageLayout({ children }: React.PropsWithChildren) {
  const sid = useCheckoutSid()
  const isRouterReady = useRouterIsReady()
  let content = children

  if (!isRouterReady) {
    return null
  }

  if (!sid)
    content = <CheckoutErrorDialog />

  return (
    <div
      className={
        styles.pageLayout
      }
    >
      {content}
    </div>
  )
}
